import React from 'react';
import {
    Table,
    Row,
    Spin,
    Pagination,
} from 'antd';

import { asyncGet, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';


class AgencyAnalysis extends React.Component {
    // state = {
    //     selectedRowKeys: [],
    // };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    onSelectChange = selectedRowKeys => {
        this.props.getTransferData({ selectedRowKeys });
    }

    render() {
        let { list, uiStatus, pagination } = this.props;
        let { total, current, pageSize } = pagination;
        let totalPage = Math.ceil(total / pageSize);
        let { isLoading } = uiStatus;

        const rowSelection = {
            //selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: 'eID',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '开始时间',
                dataIndex: 'beginTime',
                key: 'beginTime',
            },
            {
                title: '结束时间',
                dataIndex: 'endTime',
                key: 'endTime',
            },
            {
                title: '状态',
                dataIndex: 'statusName',
                key: 'statusName',
            },
            {
                title: '责任人',
                dataIndex: 'principal',
                key: 'principal',
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        defaultExpandAllRows={false}
                        pagination={false}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.todayStartTask.list,
    pagination: state.todayStartTask.pagination,
    proxyrepeatinfo: state.todayStartTask.proxyrepeatinfo,
    uiStatus: state.todayStartTask.uiStatus,
    agentsGroup: state.todayStartTask.agentsGroup,
    transferData: state.todayStartTask.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    reStart: params => dispatch(reStart(params)),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);






// WEBPACK FOOTER //
// ./pages/task/todayStartTask/index.js